// extracted by mini-css-extract-plugin
export default {"container":"topInfo_container__8T-b6","info":"topInfo_info__JgbnM","social":"topInfo_social__RWhiG"};